// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IoZFV","content":"styles_content__MELGm"};